<template>
  <div style="width: 100%;height: 100%">
    <div>
      <el-row>
        <el-col>
          <div class="elCol">
            <div>
              <el-button :disabled="addChildType" :title="$t('organizationMge.btnAddChild')"
                         :type="addChildType == false ? 'primary':'info'" icon="el-icon-control-addchild"
                         @click="addTree(1)">
                {{ $t('organizationMge.btnAddChild') }}
              </el-button>
              <!--              <el-button :type="addSiblingType == false ? 'primary':'info'" icon="el-icon-control-addsibling"-->
              <!--                         :disabled="addSiblingType" :title="$t('organizationMge.btnAddSibling')"-->
              <!--                         @click="addTree(2)">{{ $t('organizationMge.btnAddSibling') }}-->
              <!--              </el-button>-->
            </div>
            <div style="display: flex;justify-content: flex-start">
              <el-input v-model="searchEquipment" :placeholder="$t('organizationMge.search')"
                        class="searchClass"
                        clearable style="width: 300px;margin-right:20px" @change="search" @clear="clear">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <div style="margin-right:20px">
                <el-popover placement="bottom" popper-class="statusClass" trigger="click" width="200">
                  <div v-for="item in statusFilterA" style="margin: 5px">
                    <el-checkbox :style="{color:item.color}" :value="item.status" @change="filterCard(item)">
                      {{ item.name }}
                    </el-checkbox>
                  </div>
                  <div slot="reference" class="d-content-cox-rigth-btn">
                    <div class="d-content-cox-rigth-btn-title">{{ $t('organizationMge.statusFilter') }}</div>
                    <i class="file-btn-icon el-icon-control-foldDown d-content-cox-rigth-btn-icon"></i>
                  </div>
                </el-popover>
              </div>
              <div class="Thumbnail">
                <div
                  :style="{'background-color':switchColor === 0 ? '#409eff' : '','color':switchColor === 0 ? '#ffffff' : ''}"
                  class="Thumbnail-item"
                  @click="SwitchThumbnail(0)">
                  <i class=" el-icon-control-icon_list"></i>
                </div>
                <div
                  :style="{'background-color':switchColor === 1 ? '#409eff' : '','color':switchColor === 1 ? '#ffffff' : ''}"
                  class="Thumbnail-item"
                  @click="SwitchThumbnail(1)">
                  <i class=" el-icon-control-icon_grid"></i>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="contain">
      <div class="left">
        <div class="content-left-tree">
          <div class="groups">
            <!--<lazyTree v-if="treeShow" ref="pubTree" :checked="tcheack" :lazyType="lazyType" :renderContentType="renderContentType" :renderContent="renderContent" :dropCallBack="dropCallBack" :nodeKey="nodeKey" :propsName="propsName" :tnodeCallBack="tnodeCallBack"  :tgetRootNode="tgetRootNode" :tgetChildNode="getSelectLowerOrgTreeByOrgId"></lazyTree>-->
            <tree v-if="treeShow" ref="pubTree" :checked="tcheack" :dropCallBack="dropCallBack"
                  :propsName="propsName" :renderContent="renderContent"
                  :renderContentType="renderContentType" :tnodeCallBack="tnodeCallBack" :tnodeKey="nodeKey"
                  :treeData="treeDataList"
                  @handleCheck="handleCheck"
            ></tree>
          </div>
        </div>
      </div>
      <div class="right">
        <div v-show="switchColor=== 1" class="right-content">
          <div v-for="item in company_card" class="card">
            <div class="card-header">
              <p class="card-header-p-one">{{ item.orgName }}</p>
              <div
                :style="{borderColor:selectStatus(item.mediaTimeState).color,backgroundColor:selectStatus(item.mediaTimeState).backGround}"
                class="card-header-p-two-bg">
                <p :style="{color:selectStatus(item.mediaTimeState).color}" class="card-header-p-two">
                  <!--                <p class="card-header-p-two" style="color: #FFFFFF">-->
                  {{ selectStatus(item.mediaTimeState).text }}
                </p>
              </div>
            </div>
            <div class="card-body">
              <div class="card-body-one flex-between">
                <p class="card-body-one-p1">{{ $t('organizationMge.admin') }}</p>
                <p class="card-body-one-p2">{{ item.userName }}</p>
              </div>
              <!--              <div class="card-body-five flex-between">
                              <p class="card-body-five-p1">{{$t('repairLog.tableStatus')}}</p>
                              <div class="card-body-five-p2">
                              <p v-show="item.mediaTimeState === 0" class="card-body-three-p2" style="color: #606266">
                                {{ $t('organizationMge.Trial') }}</p>
                              <p v-show="item.mediaTimeState === 1" class="card-body-three-p2" style="color: #606266">
                                {{ $t('organizationMge.Normal') }}
                              </p>
                              <p v-show="item.mediaTimeState === 2" class="card-body-three-p2" style="color: #ff5f5f">
                                {{ $t('organizationMge.Advent') }}
                              </p>
                              <p v-show="item.mediaTimeState === 3" class="card-body-three-p2" style="color: #ff5f5f">
                                {{ $t('organizationMge.Expired') }}
                              </p>
                              </div>
                            </div>-->
              <div class="card-body-three flex-between">
                <p class="card-body-three-p1">{{ $t('organizationMge.ValidityPeriod') }}</p>
                <p v-show="item.mediaState === 0" class="card-body-three-p2" style="color: #606266">
                  {{ $t('organizationMge.Trial') }}</p>
                <p v-show="item.mediaState === 1" class="card-body-three-p2" style="color: #606266">
                  {{ item.stopDate }}</p>
                <p v-show="item.mediaState === 2" class="card-body-three-p2" style="color: #606266">
                  {{ $t('organizationMge.Permanent') }}</p>
              </div>
              <div v-if="mediaOperator === 1" class="card-body-two flex-between">
                <p class="card-body-two-p1">{{ $t('organizationMge.serviceState') }}</p>
                <p class="card-body-two-p2">
                  <el-switch
                    :active-value='1'
                    :inactive-value='0'
                    :value=item.isOff
                    active-color="#409eff"
                    active-text="ON"
                    class="demo"
                    inactive-color="#9d9d9d"
                    inactive-text="OFF"
                    @change="clickSwitch(item)"
                  >
                  </el-switch>
                </p>
              </div>
              <div class="card-body-four flex-between">
                <el-button style="width: 122px;height: 40px;border-radius: 4px;background: #ebf5ff;color: #409EFF;"
                           type="plain"
                           @click="editTree('', item)">
                  {{ $t('organizationMge.edit') }}
                </el-button>
                <el-button
                  style="width: 122px;height: 40px;border-radius: 4px;background: #ebf5ff;color: #409EFF;margin-left: 20px"
                  type="plain"
                  @click="delTree('', item)">
                  {{ $t('organizationMge.del') }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <!--        111111111111111-->
        <div v-show="switchColor=== 0" class="list">
          <el-table
            :data="company_card"
            :header-row-style="styleObj"
            :row-style="rowStyle"
            border
          >
            <el-table-column
              :label="$t('organizationMge.TerminalName') "
              align="center"
              min-width="150"
              prop="equipmentId"
              width="300"
            >
              <template slot-scope="scope">
                <!--                <div style="text-align: center;margin-top: 8px">-->
                <span :title="scope.row.orgName" class="tableOrglist"
                >{{ scope.row.orgName }}</span>
                <!--                </div>-->
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('organizationMge.Competence') "
              align="center"
              min-width="220"
              prop="equipmentId"
            >
              <template slot-scope="scope">
                <!--                <div style="text-align: center;margin-top: 8px">-->
                <span :title="scope.row.userName" class="tableOrglist">
                {{ scope.row.userName }}
              </span>
                <!--                </div>-->
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('repairLog.tableStatus')"
              align="center"
              min-width="100">
              <template slot-scope="scope">
                  <span>
                    <p v-show="scope.row.mediaTimeState === 0" class="card-body-three-p2" style="color: #606266">
                  {{ $t('organizationMge.Trial') }}</p>
                <p v-show="scope.row.mediaTimeState === 1" class="card-body-three-p2" style="color: #606266">
                  {{ $t('organizationMge.Normal') }}
                </p>
                <p v-show="scope.row.mediaTimeState === 2" class="card-body-three-p2" style="color: #f59a23">
                  {{ $t('organizationMge.Advent') }}
                </p>
                    <p v-show="scope.row.mediaTimeState === 3" class="card-body-three-p2" style="color: #ff5f5f">
                  {{ $t('organizationMge.Expired') }}
                    </p>
                </span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('organizationMge.ValidityPeriodLIST')"
              align="center"
              min-width="200">
              <template slot-scope="scope">
                   <span>
                <p v-show="scope.row.mediaState === 0" class="card-body-three-p2" style="color: #606266">
                  {{ $t('organizationMge.Trial') }}</p>
                <p v-show="scope.row.mediaState === 1" class="card-body-three-p2" style="color: #606266">
                  {{ scope.row.stopDate }}</p>
                <p v-show="scope.row.mediaState === 2" class="card-body-three-p2" style="color: #606266">
                  {{ $t('organizationMge.Permanent') }}</p>
                 </span>
              </template>
            </el-table-column>

            <el-table-column
              v-if="mediaOperator === 1"
              :label="$t('organizationMge.serviceStateLIST')"
              align="center"
              min-width="200">
              <template slot-scope="scope">
                <!--                <div style="text-align: center;margin-top: 8px">-->
                <span class="tableOrglist">
                 <el-switch
                   :active-value='1'
                   :inactive-value='0'
                   :value=scope.row.isOff
                   active-color="#409eff"
                   active-text="ON"
                   class="demo"
                   inactive-color="#9d9d9d"
                   inactive-text="OFF"
                   @change="clickSwitch(scope.row)"
                 >
                  </el-switch>
              </span>
                <!--                </div>-->
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('organizationMge.operate') "
              align="center"
              fixed="right"
              width="100">
              <template slot-scope="scope">
                <span>
                  <i :title="$t('organizationMge.edit')" class="group-list-right el-icon-control-edit "
                     @click="editTree('', scope.row)"></i>
                  <i :title="$t('organizationMge.del')" class="group-list-right el-icon-control-delete "
                     @click="delTree('', scope.row)"></i>
                 </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!--       2222222222222222 -->
        <div class="pagination">
          <el-pagination
            :current-page="currentPage"
            :page-size="pageSize"
            :page-sizes="[12, 24, 36]"
            :total="totalRow"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
          </el-pagination>
        </div>
        <div style="width: 100%;height: 50px"></div>
      </div>
    </div>
    <el-dialog :title="dialogStatus == 0? $t('organizationMge.add'):$t('organizationMge.edit')"
               :visible.sync="dialogFormVisible" width="600px">
      <el-form v-if="dialogFormVisible" ref="dataFormRef" :model="dataForm" :rules="rules" label-width="190px">
        <el-form-item :label="$t('organizationMge.schoolName')" :label-position="labelPosition" prop="schoolName">
          <el-input v-model="dataForm.schoolName" maxlength="40"></el-input>
        </el-form-item>
        <el-form-item :label="$t('organizationMge.type')" :label-position="labelPosition" class="" label-width="190px"
                      prop="radioName">
          <el-radio-group v-model="dataForm.radioGroupChecked" :disabled="editRadio">
            <el-radio v-for="(item,$index) in dataForm.radioGroup" :key="item.organizationValue"
                      :label="item.organizationValue" @change.native.stop="radioEvent(item,$index)">
              {{ item.organizationName }}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <!--        <el-form-item :label="$t('organizationMge.accountPrefix')" :error="adminNameErrorMsg"
                              :prop="(dataForm.radioGroupChecked == 11 && dialogStatus == 0) ? 'terminalOrgNum':((dataForm.radioGroupChecked == 11 && dialogStatus == 1) ? 'terminalOrgNum':'') ">-->
        <el-form-item v-if="dataForm.radioGroupChecked == 11" :error="terminalOrgNumErrorMsg"
                      :label="$t('organizationMge.accountPrefix')"
                      :label-position="labelPosition" prop="adminName">
          <span v-show="dataForm.radioGroupChecked == 10 ? true:false"
                style="color:rgba(0,0,0,1)">{{ orgNum }}</span><span style="color:rgba(0,0,0,1)"></span>
          <el-input v-if="dataForm.radioGroupChecked == 10 ? false:true" v-model="dataForm.terminalOrgNum"
                    maxlength="8" style="width: 100px"></el-input>
          +
          <el-input ref="adminName" v-model="dataForm.adminName" maxlength="10" style="width: 210px"
                    @input="changeValue"></el-input>
          <i class="group-list-right el-icon-control-copy " title="copy" @click="copy"></i>
        </el-form-item>
        <el-form-item v-else :label="$t('organizationMge.accountPrefix')" :label-position="labelPosition"
                      prop="adminNameDL">
          <span v-show="dataForm.radioGroupChecked == 10 ? true:false"
                style="color:rgba(0,0,0,1)">{{ orgNum }}</span><span style="color:rgba(0,0,0,1)"></span>
          <el-input v-if="dataForm.radioGroupChecked == 10 ? false:true" v-model="dataForm.terminalOrgNum"
                    maxlength="8" style="width: 100px"></el-input>
          +
          <el-input ref="adminName" v-model="dataForm.adminNameDL" maxlength="10" style="width: 210px"
                    @input="changeValue"></el-input>
          <i class="group-list-right el-icon-control-copy " title="copy" @click="copy"></i>
        </el-form-item>
        <el-form-item class="" label=" " label-width="190px" prop="radioName">
          <!--<div style="color: #ED2020;font-size:14px;margin-top: -5px; line-height: 23px;">{{$t('organizationMge.account')}}</div>-->
          <div style="line-height: 23px;color:rgba(0,0,0,0.43);font-size: 14px;word-break: break-word;">
            {{ $t('organizationMge.titleOrganization') }}
          </div>
        </el-form-item>
        <!--        <el-form-item :label="$t('organizationMge.adminPwd')" :label-position="labelPosition" :error="adminPwdErrorMsg"
                              :prop="(dataForm.radioGroupChecked == 11 && dialogStatus == 0) ? 'adminPwd': (dataForm.radioGroupChecked == 11 ? '': dataForm.nameType === true ? 'adminPwd':'')">-->
        <!--        <el-form-item :label="$t('organizationMge.adminPwd')" :label-position="labelPosition" prop="adminPwd" :error="adminPwdErrorMsg" key="adminPwd1" v-if="dataForm.radioGroupChecked == 11">
                  <el-input v-model="dataForm.adminPwd" @input="adminPwdValue" maxlength="20"></el-input>
                </el-form-item>-->
        <el-form-item v-if="dataForm.radioGroupChecked == 11 && dialogStatus == 0" key="adminPwd1"
                      :label="$t('organizationMge.adminPwd')"
                      :label-position="labelPosition" prop="adminPwd">
          <el-input v-model="dataForm.adminPwd" maxlength="20" @input="adminPwdValue"></el-input>
        </el-form-item>
        <el-form-item v-else key="adminPwd2" :label="$t('organizationMge.adminPwd')"
                      :label-position="labelPosition" prop="adminPwdDL">
          <el-input v-model="dataForm.adminPwdDL" maxlength="20" @input="adminPwdValue"></el-input>
        </el-form-item>
        <el-form-item v-show="mediaOperator === 1 ? dataForm.radioGroupChecked == 11 : false"
                      :error="pickerValueOneErrorMsg"
                      :label="$t('organizationMge.mediaValidityPeriod')"
                      :label-position="labelPosition">
          <div style="display: flex;justify-content: flex-start">
            <el-select v-model="dataForm.selectValue" placeholder="请选择" prop="selectOption"
                       style="width: 212px;margin-bottom: 15px;" @change="changeStatus">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select v-show="dataForm.selectValue == 1" v-model="dataForm.selectYear" placeholder="请选择"
                       prop="selectOption" style="width: 133px;margin-left: 10px" @change="changeYear">
              <el-option
                v-for="item in optionsYear"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>

          <div v-if="dataForm.selectValue === 1" style="display: flex">
            <el-date-picker
              v-model="dataForm.pickerValueOne"
              :placeholder="$t('organizationMge.StartDate')"
              style="width: 170px"
              type="date"
              value-format="yyyy-MM-dd"
              @change="changeStatus"
            >
            </el-date-picker>
            <div style="width: 15px;text-align: center">
              -
            </div>
            <el-date-picker
              v-model="dataForm.pickerValueTwo"
              :disabled="true"
              :placeholder="$t('organizationMge.EndDate')"
              prefix-icon="none"
              style="width: 170px"
              type="date"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <P style="margin-bottom: 15px">
          {{ $t('organizationMge.contactInformation') }}
        </P>
        <!--        <div>
                  <el-form-item :label="$t('organizationMge.company')" maxlength="20" :label-position="labelPosition" key="company"
                                :prop="(dataForm.radioGroupChecked == 11 && dialogStatus == 0) ? 'company':((dataForm.radioGroupChecked == 11 && dialogStatus == 1) ? 'company':'') ">
                    <el-input v-model="dataForm.company" maxlength="20"></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item :label="$t('organizationMge.email')" maxlength="20" :label-position="labelPosition" key="email"
                                :prop="(dataForm.radioGroupChecked == 11 && dialogStatus == 0) ? 'email':((dataForm.radioGroupChecked == 11 && dialogStatus == 1) ? 'email':'') ">
                    <el-input v-model="dataForm.email" maxlength="20"></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item :label="$t('organizationMge.phone')" maxlength="20" :label-position="labelPosition" key="phone"
                                :prop="(dataForm.radioGroupChecked == 11 && dialogStatus == 0) ? 'phone':((dataForm.radioGroupChecked == 11 && dialogStatus == 1) ? 'phone':'') ">
                    <el-input v-model="dataForm.phone" maxlength="20"></el-input>
                  </el-form-item>
                </div>-->

        <el-form-item v-if="dataForm.radioGroupChecked == 11" key="company"
                      :label="$t('organizationMge.company')" :label-position="labelPosition" prop='company'>
          <el-input v-model="dataForm.company" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item v-else key="companyDL" :label="$t('organizationMge.company')" :label-position="labelPosition"
                      prop=''>
          <el-input v-model="dataForm.companyDL" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item v-if="dataForm.radioGroupChecked == 11" key="email"
                      :label="$t('organizationMge.email')" :label-position="labelPosition" prop='email'>
          <el-input v-model="dataForm.email" maxlength="100" minlength="5"></el-input>
        </el-form-item>
        <el-form-item v-else key="emailDL" :label="$t('organizationMge.email')" :label-position="labelPosition"
                      prop='emailDL'>
          <el-input v-model="dataForm.emailDL" maxlength="100" minlength="5"></el-input>
        </el-form-item>
        <el-form-item v-if="dataForm.radioGroupChecked == 11" key="phone"
                      :label="$t('organizationMge.phone')" :label-position="labelPosition" prop='phone'>
          <el-input v-model="dataForm.phone" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item v-else key="phoneDL" :label="$t('organizationMge.phone')" :label-position="labelPosition"
                      prop='phoneDL'>
          <el-input v-model="dataForm.phoneDL" maxlength="20"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createData('dataFormRef')">{{ $t('organizationMge.save') }}</el-button>
        <el-button @click="dialogFormVisible = false">{{ $t('organizationMge.cancel') }}</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
// import lazyTree from '@/views/tree/lazyTree.vue';
import tree from '@/views/tree/tree.vue';
import {
  deleteOrganization,
  insertOneOrg,
  selectAgencyNumByOrgId,
  selectLowerOrgTreeByOrgId,
  selectMediaOrg,
  selectOrgEntityByOrgId,
  selectOrgNum,
  selectUserMediaInfo,
  selectUserOrgMediaTree,
  updateMediaState,
  updateOrganization,
  updateOrgOrder
} from '@/api/organization'

import {parseTime} from '@/utils'
//加载密码加密js
import {hex_sha1} from '@/common/js/ha1'
import Clipboard from 'clipboard';
import {validateEmail} from "@/utils/validate";

export default {
  name: 'complexTable',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.recordBehaviorsBefore(to);
    });
  },
  beforeRouteLeave(to, from, next) {
    this.recordBehaviorsAfter(from);
    next();
  },
  data() {
    let _this = this
    var terminalOrgNum = (rule, value, callback) => {
      if (value.trim() === '') {
        callback(new Error(_this.$t('login.loginTitle1001')));
      } else {
        var reg = /^[a-zA-Z][a-zA-Z0-9]{3,15}$/;
        if (!reg.test(value)) {
          callback(new Error(_this.$t('login.loginTitleUserName')));
        } else {
          callback();
        }
      }
    }
    const validatePhone = (rule, value, callback) => {
      if (value.trim() === '') {
        callback();
      } else {
        if (!(new RegExp(/^[\d (),+-]+$/).test(value))) {
          callback(new Error(_this.$t('userMge.titlePhoneFormat')));
        } else {
          callback();
        }
      }
    }
    return {
      pickerValueOneErrorMsg: '',
      terminalOrgNumErrorMsg: '',
      orgId: '',
      editRadio: false,
      mediaOperator: 0,
      rowStyle: {
        height: '45px',
      },
      styleObj: {
        color: '#000000',
        lineHeight: '40px',
        fontSize: '18px',
        fontFamily: 'inter',
        fontWeight: 700,
      },
      switchColor: 1,
      checkList: [],
      selectCards: [],
      keyword: null,
      currentPage: 1,
      pageSize: 12,
      totalRow: 0,
      searchEquipment: '',
      options: [{
        value: 0,
        label: this.$t('organizationMge.Trial')
      }, {
        value: 1,
        label: this.$t('organizationMge.AnnualBilling')
      }, {
        value: 2,
        label: this.$t('organizationMge.Permanent')
      }],
      optionsYear: [{
        value: 1,
        label: 1
      }, {
        value: 2,
        label: 2
      }, {
        value: 3,
        label: 3
      }],
      a: false,
      defaultCheckedKeys: [],
      CheckedKeys: '',
      company_card: [],
      value2: true,
      statusFilterA: [{
        name: this.$t('organizationMge.Trial'),
        color: '#6DD400',
        value: 0,
        status: true
      }, {
        name: this.$t('organizationMge.Normal'),
        color: '#6DD400',
        value: 1,
        status: true
      }, {
        name: this.$t('organizationMge.Advent'),
        color: '#f59a23',
        value: 2,
        status: true
      }, {
        name: this.$t('organizationMge.Expired'),
        color: '#E02020',
        value: 3,
        status: true
      }],
      dialogStatus: 0,
      dialogFormVisible: false,
      temp: {
        id: undefined,
        importance: 1,
        remark: '',
        timestamp: new Date(),
        title: '',
        type: '',
        status: 'published'
      },
      isLoad: 0, // 弹窗树组件是否加载完成
      addCheckedNodes: [], //选中的节点数组
      checked: false,
      labelPosition: 'right',
      dataForm: {
        schoolId: '',
        schoolName: '',  //名称
        organizationNum: '', //机构数量
        equipmentNum: '', //设备数量
        organization: "1",
        sort: '',  //排序
        adminName: '', //机构管理员账号
        adminNameDL: '', //机构管理员账号
        adminPwd: '', //机构管理员密码
        adminPwdDL: '',
        serialNum: '',//序列号
        accountPrefix: 'RD',//前缀
        realName: '',
        // orgType:10,//组织机构类型
        radioGroup: [
          {organizationName: _this.$t("organizationMge.terminalMechanism"), organizationValue: "11"},
          {organizationName: _this.$t("organizationMge.organization"), organizationValue: "10"}
        ],
        radioGroupChecked: "10",
        userId: "",
        terminalOrgNum: '',//终端机构自定义前缀
        errorTitle: '',
        nameType: false,
        company: '',
        email: '',
        phone: '',
        pickerValueOne: '',
        pickerValueTwo: '',
        selectValue: 0,
        selectYear: 1,
        phoneDL: '',
        companyDL: '',
        emailDL: '',

      },
      rules: {
        schoolName: [
          {required: true, message: _this.$t("input.thisField"), trigger: 'blur'},
          /*{min: 1, max: 20, message: this.$t('feedback.GroupNameLength'), trigger: 'blur'},*/
        ],
        terminalOrgNum: [
          {required: true, validator: _this.$t("input.thisField"), trigger: 'blur'},
        ],
        sort: [
          {required: true, message: _this.$t("input.thisField"), trigger: 'blur'},
        ],
        adminName: [
          {required: true, message: _this.$t("input.thisField"), trigger: 'blur'},
          {
            pattern: /^[^\u4e00-\u9fa5]{0,}$/,
            message: _this.$t('input.passwordNoChinese'),
            trigger: 'blur'
          },
          {
            pattern: /^[^\~!#$%^&*()+<>?:"{},\/;'[\]]{0,}$/,
            message: _this.$t('feedback.emailSpecialString'),
            trigger: 'blur'
          }
        ],
        adminNameDL: [
          /*{required: true, message: _this.$t("input.thisField"), trigger: 'blur'},*/
          {
            pattern: /^[^\u4e00-\u9fa5]{0,}$/,
            message: _this.$t('input.passwordNoChinese'),
            trigger: 'blur'
          },
          {
            pattern: /^[^\~!#$%^&*()+<>?:"{},\/;'[\]]{0,}$/,
            message: _this.$t('feedback.emailSpecialString'),
            trigger: 'blur'
          }
        ],
        adminPwd: [
          {required: true, message: _this.$t("input.thisField"), trigger: 'blur'},
          {
            pattern: /^[^\u4e00-\u9fa5]{0,}$/,
            message: _this.$t('input.passwordNoChinese'),
            trigger: 'blur'
          },
          {
            pattern: /^(?=.*[A-Za-z])(?=.*\d).{6,}$/,
            message: _this.$t('userMge.checkPasswordTitleTwo'),
            trigger: 'blur'
          },
        ],
        adminPwdDL: [
          // {required: true, message: _this.$t("input.thisField"), trigger: 'blur'},
          {
            pattern: /^[^\u4e00-\u9fa5]{0,}$/,
            message: _this.$t('input.passwordNoChinese'),
            trigger: 'blur'
          },
          {
            pattern: /^(?=.*[A-Za-z])(?=.*\d).{6,}$/,
            message: _this.$t('userMge.checkPasswordTitleTwo'),
            trigger: 'blur'
          },
        ],
        realName: [
          {required: true, message: _this.$t("input.thisField"), trigger: 'blur'},
        ],
        selectOption: [
          {required: true, message: _this.$t("input.thisField"), trigger: 'blur'},
        ],
        pickerValueOne: [
          {required: true, message: _this.$t("input.thisField"), trigger: 'blur'},
        ],
        company: [
          {required: true, message: _this.$t("input.thisField"), trigger: 'blur'},
        ],
        companyDL: [
          /*{required: true, message: _this.$t("input.thisField"), trigger: 'blur'},*/
        ],
        email: [
          {
            required: true,
            message: _this.$t("input.thisField"),
            trigger: 'blur'
          },
          {min: 5, max: 100, message: this.$t('feedback.emailLength'), trigger: 'blur'},
          {
            pattern: /^[^\u4e00-\u9fa5]{0,}$/,
            message: _this.$t('feedback.emailNoChinese'),
            trigger: 'blur'
          },
          {
            pattern: /^[^\~!#$%^&*()<>?:"{},\/;'[\]]{0,}$/,
            message: _this.$t('feedback.emailSpecialString'),
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (validateEmail(value)) {
                callback();
              }
              callback(new Error(_this.$t('feedback.emailTrueRule')));
            },
            trigger: "blur",
          },
        ],
        emailDL: [
          {min: 5, max: 100, message: this.$t('feedback.emailLength'), trigger: 'blur'},
          {
            pattern: /^[^\u4e00-\u9fa5]{0,}$/,
            message: _this.$t('feedback.emailNoChinese'),
            trigger: 'blur'
          },
          {
            pattern: /^[^\~!#$%^&*()<>?:"{},\/;'[\]]{0,}$/,
            message: _this.$t('feedback.emailSpecialString'),
            trigger: 'blur'
          },
          {
            pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: _this.$t('feedback.emailSpecialString'),
            trigger: 'blur'
          },
        ],
        phone: [
          {required: true, message: _this.$t("input.thisField"), trigger: 'blur'},
          {trigger: 'blur', validator: validatePhone}
        ],
        phoneDL: [
          {
            pattern: /^[\d (),+-]+$/,
            message: _this.$t('feedback.emailSpecialString'),
            trigger: 'blur'
          }
        ],
      },
      propsName: {
        children: 'children',
        label: 'orgName'
      }
      ,
      nodeKey: 'orgId',
      renderContentType: true,
      treeDataList: [],
      treeShow: true, //树显示
      tcheack: false, // 是否显示复选框
      treedata: [],
      treeListStyle: {'height': '1000',}
      ,
      tableData: [],
      lazyType: true,
      childAndSameLevel: 1,
      addSiblingType: false, //是否能添加兄弟节点
      addChildType: false, //是否能添加子节点
      entityByorgId: '',  //最高级orgId
      orgNum: '',//组织机构代码
      tnodeOrgId: '',//树选中ID
      tnodePid: '',//树选中父ID
      firstOrgNum: '',
      adminNameErrorMsg: '',
      adminPwdErrorMsg: '',
      companyErrorMsg: '',
      emailErrorMsg: '',
      phoneErrorMsg: '',
    }
  },
  computed: {
    /*'dataForm.pickerValueOne'(){
      let year = this.selectYear
      let dateOne = this.dataForm.pickerValueOne
       return this.dataForm.pickerValueTwo =  this.moment(dateOne).add({years:year}).format('YYYY-MM-DD')
    }*/
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'info',
        deleted: 'danger'
      }
      return statusMap[status]
    },
    // typeFilter(type) {
    //   return calendarTypeKeyValue[type]
    // }
  },
  created() {
    this.tgetRootNode()
  },
  mounted() {
    this.selectUserMediaInfo()
  },
  watch: {
    'dataForm.pickerValueOne'(dateOne) {
      let year = this.dataForm.selectYear
      return this.dataForm.pickerValueTwo = this.moment(dateOne).add({years: year}).format('YYYY-MM-DD')
    },
    /*phoneDL:function (val,oldVal){
      this.dataForm.phone = val;
    },
    emailDL:function (val,oldVal){
      this.dataForm.email = val;
    },
    phone:function (val,oldVal){
      this.dataForm.phoneDL = val;
    },
    email:function (val,oldVal){
      this.dataForm.emailDL = val;
    },*/
    /*company_card:function (val){
      this.tabObj.totalRow = val.length;
    },*/
    dataForm: function (val) {
      if (val.radioGroupChecked == 10) {
        if (val.trim() == "") {
          this.dataForm.adminName = ''
          this.dataForm.nameType = false
        } else {
          this.dataForm.nameType = true
        }
      } else {
        this.dataForm.nameType = false
      }
    },
    adminName: function (val) {
      if (this.radioGroupChecked == 11) {
        this.dataForm.nameType = true
      }
      if (this.dataForm.radioGroupChecked == 10) {
        if (this.dataForm.adminName.trim() == "") {
          this.dataForm.nameType = false
        } else {
          this.dataForm.nameType = true
        }
      }
    },

  },
  methods: {
    changeStatus(status) {
      if (status !== 1) {
        this.pickerValueOneErrorMsg = ''
      }
      /*console.log(typeof this.dataForm.pickerValueOne)*/
    },
    changeYear(year) {
      let Two
      let dateOne = this.dataForm.pickerValueOne;
      Two = this.moment(dateOne).add({years: year}).format('YYYY-MM-DD')
      this.$set(this.dataForm, 'pickerValueTwo', Two);
    },
    /*1111111111111111*/
    selectMediaOrg(param) {
      selectMediaOrg(param).then(res => {
        let jsonBody = res.jsonBody;
        let rtnCode = jsonBody.rtnCode;
        if (rtnCode == 0) {
          // node.loaded = true
          this.defaultCheckedKeys = jsonBody.msgBody.rows
          this.company_card = this.defaultCheckedKeys;
          this.totalRow = jsonBody.msgBody.totalNum
        } else {
          this.$message({
            message: jsonBody.msg,
            type: 'warning',
            duration: 1000
          });
        }
      })
    },
    SwitchThumbnail(num) {
      this.switchColor = num;
    },
    handleSizeChange(val) {
      let param = new Object();
      let param1 = new Object();
      param1.orgId = this.getCurrentNode() === null ? this.treeDataList[0].orgId : this.getCurrentNode().orgId
      param1.keyword = this.keyword
      param1.pageNum = this.currentPage
      param1.pageSize = val
      param.jsonBody = param1;
      this.selectMediaOrg(param);
    },
    handleCurrentChange(val) {
      let param = new Object();
      let param1 = new Object();
      param1.orgId = this.getCurrentNode() === null ? this.treeDataList[0].orgId : this.getCurrentNode().orgId
      param1.keyword = this.keyword
      this.currentPage = val;
      param1.pageNum = val
      param1.pageSize = this.pageSize
      param.jsonBody = param1;
      this.selectMediaOrg(param);
      /*selectMediaOrg(param).then(res => {
        let jsonBody = res.jsonBody;
        let rtnCode = jsonBody.rtnCode;
        if (rtnCode == 0) {
          // node.loaded = true
          this.defaultCheckedKeys = jsonBody.msgBody.rows
          this.company_card = this.defaultCheckedKeys;
          this.totalRow = jsonBody.msgBody.totalNum
        } else {
          this.$message({
            message: jsonBody.msg,
            type: 'warning',
            duration: 1000
          });
        }
      })*/
    },
    search(keyword) {
      this.keyword = keyword
      let param = new Object();
      let param1 = new Object();
      param1.orgId = this.getCurrentNode() === null ? this.treeDataList[0].orgId : this.getCurrentNode().orgId
      param1.keyword = this.keyword
      this.currentPage = 1
      param1.pageNum = this.currentPage
      this.pageSize = 12
      param1.pageSize = this.pageSize
      param.jsonBody = param1;
      this.selectMediaOrg(param);
      /*selectMediaOrg(param).then(res => {
        let jsonBody = res.jsonBody;
        let rtnCode = jsonBody.rtnCode;
        if (rtnCode == 0) {
          // node.loaded = true
          this.defaultCheckedKeys = jsonBody.msgBody.rows
          this.company_card = this.defaultCheckedKeys;
          this.totalRow = jsonBody.msgBody.totalNum
        } else {
          this.$message({
            message: jsonBody.msg,
            type: 'warning',
            duration: 1000
          });
        }
      })*/
    },
    clear() {
    },
    clickSwitch(item) {
      console.log('item', item)
      let flag = item.isOff
      let tip = ''
      let content = ''
      if (flag === 0) {
        tip = this.$t(" organizationMge.enableStreaming")
        content = this.$t(" organizationMge.enableStreamingContent")
      } else {
        tip = this.$t(" organizationMge.disableStreaming")
        content = this.$t(" organizationMge.disableStreamingContent")
      }
      this.$confirm(content, tip, {
        confirmButtonText: this.$t(" organizationMge.confirm"),
        cancelButtonText: this.$t(" organizationMge.cancel"),
        type: 'warning'
      }).then(() => {
        item.isOff = flag === 1 ? 0 : 1;
        let param = new Object();
        let param1 = new Object();
        param1.orgId = item.orgId;
        param1.isOff = item.isOff;
        param.jsonBody = param1;
        updateMediaState(param).then(res => {

        })
      }).catch(() => {
      })
    },
    filterCard(card) {
      let selectPoint = [];
      card.status = !card.status
      this.statusFilterA.forEach(item => {
        if (item.status) {
          selectPoint.push(item.value)
        }
      })
      this.company_card = [];
      this.defaultCheckedKeys.forEach(item => {
        if (selectPoint.indexOf(item.mediaTimeState) !== -1)
          this.company_card.push(item)
      })
      console.log('defaultCheckedKeys2', this.defaultCheckedKeys)
      this.totalRow = this.company_card.length;
    },
    selectCompany(orgId) {   //页面一刷新调用此方法渲染卡片
      this.defaultCheckedKeys = [];
      let param = new Object();
      let param1 = new Object();

      if (orgId) {
        param1.orgId = orgId
      } else {
        param1.orgId = this.getCurrentNode() === null ? this.treeDataList[0].orgId : this.getCurrentNode().orgId
      }
      this.$nextTick(function () {
        this.$nextTick(function () {
          this.$refs.pubTree.setCurrentKey(param1.orgId)
        })
      })
      param1.keyword = this.keyword
      param1.pageNum = this.currentPage
      param1.pageSize = this.pageSize
      param.jsonBody = param1;
      this.selectMediaOrg(param);
    },
    handleCheck(data) {   //点击树渲染卡片
      /*点击树时重置状态筛选*/
      this.statusFilterA.forEach(item => {
        item.status = true;
      })

      this.CheckedKeys = data.orgId;
      this.defaultCheckedKeys = [];
      let param = new Object();
      let param1 = new Object();
      param1.orgId = this.CheckedKeys == null ? this.treeDataList[0].orgId : this.CheckedKeys
      /*param1.orgId = this.getCurrentNode() === null ? this.treeDataList[0].orgId : this.getCurrentNode().orgId*/
      param1.keyword = this.keyword
      //
      this.currentPage = 1;
      param1.pageNum = this.currentPage
      param1.pageSize = this.pageSize
      param.jsonBody = param1;
      this.selectMediaOrg(param);
    },
    loopChildNode(e) {   //递归树节点，获得子节点
      if (e.children.length === 0 && e.orgType == 11) {
        this.defaultCheckedKeys.push(e)
      } else {
        e.children.forEach((item) => {
          this.loopChildNode(item)
        })
      }
    },
    selectStatus(status) {
      let color = '';
      let backGround = ''
      let text = ''
      switch (status) {
        case 0:
          color = '#6DD400';
          backGround = 'rgba(109,212,0,0.11)';
          text = this.$t('organizationMge.Trial');
          break
        case 1:
          color = '#6DD400';
          backGround = 'rgba(109,212,0,0.11)';
          text = this.$t('organizationMge.Normal');
          break
        case 2:
          color = '#f59a23';
          backGround = 'rgba(250,100,0,0.11)';
          text = this.$t('organizationMge.Advent');
          break
        case 3:
          color = '#E02020';
          backGround = 'rgba(224,32,32,0.11)';
          text = this.$t('organizationMge.Expired');
          break
      }
      return {color, text, backGround}
    },
    adminPwdValue: function (val) {
      this.adminPwdErrorMsg = ''
      if (this.dataForm.radioGroupChecked == 11) {
        if (this.dataForm.adminPwd.trim() == "") {
          this.adminPwdErrorMsg = this.$t("input.thisField")
        }
      } else if (this.dataForm.radioGroupChecked == 10) {
        if (val.trim() == "") {
          if (this.dataForm.adminPwd.trim() == "") {
            this.adminPwdErrorMsg = ""
          }
        } else {
          if (this.dataForm.adminPwd.trim() == "") {
            this.adminPwdErrorMsg = this.$t("input.thisField")
          }
        }
      }
    },
    changeValue: function (val) {
      this.adminPwdErrorMsg = ''

      if (this.dataForm.radioGroupChecked == 11) {
        this.dataForm.nameType = true
      } else if (this.dataForm.radioGroupChecked == 10) {
        if (val.trim() == "") {
          this.dataForm.nameType = false
        } else {
          this.dataForm.nameType = true
        }
      }
      // if(this.dataForm.adminName == 11){
      //
      // }
    },
    copy() {
      let Url = ""
      let _this = this
      if (_this.dataForm.radioGroupChecked == 11) {
        Url = _this.dataForm.terminalOrgNum + _this.dataForm.adminName
      } else {
        Url = _this.orgNum + _this.dataForm.adminNameDL
      }
      let clipboard = new Clipboard('.el-icon-control-copy', {
        text: function () {
          return Url;
        }
      });
      clipboard.on('success', e => {
        _this.$message({
          message: _this.$t("organizationMge.copySuccess"),
          type: 'success'
        });
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        _this.$message({
          message: _this.$t("organizationMge.copyError"),
          type: 'warning',
          duration: 1000
        });
        // 释放内存
        clipboard.destroy()
      })
    },
    /* getChecked() {

     },*/
    //单选框触发事件
    radioEvent() {
      if (this.dataForm.radioGroupChecked == 11) {
        if (this.dataForm.adminName.trim() == "") {
          this.dataForm.adminName = ''
          this.dataForm.nameType = false
        } else {
          this.dataForm.nameType = true
        }
      } else {
        this.adminPwdErrorMsg = ''
        this.dataForm.nameType = false
      }

    },
    getCurrentNode() {
      let _this = this
      let currentNode = _this.$refs.pubTree.getCurrentNode()
      return currentNode
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    },
    //确定
    createData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _this = this
          let currentNode = _this.getCurrentNode() === null ? this.treeDataList[0] : this.getCurrentNode()
          let prame = Object()
          let prame1 = Object()
          /*console.log('currentNode1',currentNode)*/
          if (_this.dialogStatus == 1) {    //0是添加 1是修改
            prame1.id = _this.dataForm.schoolId
            prame1.userId = _this.dataForm.userId
            prame1.orgId = _this.orgId
          } else {
            if (_this.childAndSameLevel == 1) {
              prame1.pid = currentNode.orgId == undefined ? '' : currentNode.orgId
            } else {
              prame1.pid = currentNode.pId
            }
          }

          prame1.organizationaName = _this.dataForm.schoolName //名称
          prame1.limitMediaDevice = 100
          prame1.limitDevice = 1
          prame1.orgType = _this.dataForm.radioGroupChecked  //组织机构类型 10 机构 11终端组织 默认0
          // if(_this.dialogStatus == 0){
          prame1.realName = _this.dataForm.realName


          if (_this.dataForm.radioGroupChecked == 11 && _this.dialogStatus == 0) {
            prame1.userPwd = hex_sha1(_this.dataForm.adminPwd) //机构管理员密码
          } else {
            prame1.userPwd = hex_sha1(_this.dataForm.adminPwdDL) //机构管理员密码
          }

          // }
          if (_this.dataForm.radioGroupChecked == 10) {

            prame1.company = _this.dataForm.companyDL
            prame1.email = _this.dataForm.emailDL
            prame1.phone = _this.dataForm.phoneDL

            // prame1.number = ""
            prame1.userName = _this.orgNum + _this.dataForm.adminNameDL //机构管理员账号
          } else {

            prame1.company = _this.dataForm.company
            prame1.email = _this.dataForm.email
            prame1.phone = _this.dataForm.phone

            prame1.isOff = 1;
            prame1.state = _this.dataForm.selectValue;
            if (_this.dataForm.selectValue === 1) {
              if (_this.dataForm.pickerValueOne == '' || _this.dataForm.pickerValueOne == null) {
                /*_this.$message({
                  message: '流媒体服务有效期开始日期未选择',
                  type: 'error',
                  duration: 1000
                });*/
                _this.pickerValueOneErrorMsg = _this.$t("organizationMge.dateNotSelected")
                return false;
              } else {
                prame1.startDate = _this.dataForm.pickerValueOne
                prame1.stopDate = _this.dataForm.pickerValueTwo
              }

            }

            if (_this.dataForm.terminalOrgNum.trim() === '' || _this.dataForm.terminalOrgNum.trim() === null) {
              _this.terminalOrgNumErrorMsg = _this.$t("organizationMge.prefixCannotBeEmpty")
              return false;
            } else {
              let detectionString = /^[a-zA-Z0-9]+$/.test(_this.dataForm.terminalOrgNum.trim())
              /*console.log('detectionString',detectionString)*/
              if (detectionString === true) {
                prame1.number = _this.dataForm.terminalOrgNum
                prame1.userName = _this.dataForm.terminalOrgNum + _this.dataForm.adminName //机构管理员账号
              } else {
                _this.terminalOrgNumErrorMsg = String(Math.random())
                _this.$nextTick(() => {
                  _this.terminalOrgNumErrorMsg = _this.$t("organizationMge.enterEnglishLetters")
                })
                return false;
              }

            }

          }
          /*if (_this.dataForm.radioGroupChecked == 11) {
            if (_this.dialogStatus == 0) {
              if (_this.dataForm.adminName.trim() == "") {
                _this.adminNameErrorMsg = _this.$t("input.thisField")
              } else {
                _this.adminNameErrorMsg = ''
              }
              if (_this.dataForm.adminPwd.trim() == "") {
                _this.adminPwdErrorMsg = _this.$t("input.thisField")
              } else {
                _this.adminPwdErrorMsg = ''
              }
            } else {
              if (_this.dataForm.adminName.trim() == "") {
                _this.adminNameErrorMsg = _this.$t("input.thisField")
              } else {
                _this.adminNameErrorMsg = ''
              }
              _this.adminPwdErrorMsg = ''
            }
          } else if (_this.dataForm.radioGroupChecked == 10) {
            if (_this.dialogStatus == 0) {
              if (_this.dataForm.adminName.trim() != "" && _this.dataForm.adminPwd.trim() == "") {
                _this.adminPwdErrorMsg = _this.$t("input.thisField")
              } else {
                _this.adminPwdErrorMsg = ''
              }
              _this.adminNameErrorMsg = ''
            } else {
              _this.adminPwdErrorMsg = ''
              _this.adminNameErrorMsg = ''
            }
          }*/
          prame.jsonBody = prame1
          if (_this.dialogStatus == 1) {
            return new Promise((resolve, reject) => {
              updateOrganization(prame).then(res => {
                let jsonBody = res.jsonBody;
                let rtnCode = jsonBody.rtnCode;
                if (rtnCode == 0) {
                  //编辑完后查询终端机构
                  /*this.defaultCheckedKeys = [];
                  let param2 = new Object();
                  let param3 = new Object();
                  param3.orgId = this.getCurrentNode() === null ? this.treeDataList[0].orgId : this.getCurrentNode().orgId
                  param3.keyword = this.keyword
                  param3.pageNum = this.currentPage
                  param3.pageSize = this.pageSize
                  param2.jsonBody = param3;
                  this.selectMediaOrg(param2);*/

                  _this.dialogStatus = 0;
                  _this.dialogFormVisible = false;
                  /*console.log('currentNode',currentNode)*/
                  _this.tgetRootNode(currentNode.orgId)
                  _this.$message({
                    message: _this.$t("organizationMge.editSuccess"),
                    type: 'success',
                    duration: 1000
                  });
                } else {
                  if (rtnCode == -1 || rtnCode == -2) {

                  } else {
                    _this.$message({
                      message: _this.$t("organizationMge.error" + rtnCode),
                      type: 'error',
                      duration: 1000
                    });
                  }
                }
              })
            })
          } else {
            return new Promise((resolve, reject) => {
              insertOneOrg(prame).then(res => {
                let jsonBody = res.jsonBody;
                let rtnCode = jsonBody.rtnCode;
                if (rtnCode == 0) {
                  _this.dialogStatus = 1;
                  _this.dialogFormVisible = false;

                  if (_this.dataForm.radioGroupChecked == 10) {
                    _this.tgetRootNode(jsonBody.msgBody.orgId)
                  } else {
                    _this.tgetRootNode(currentNode.orgId)
                  }
                  _this.$message({
                    message: _this.$t("organizationMge.addSuccess"),
                    type: 'success',
                    duration: 1000
                  });
                } else {
                  if (rtnCode == -1 || rtnCode == -2) {

                  } else {
                    _this.$message({
                      message: _this.$t("organizationMge.error" + rtnCode),
                      type: 'error',
                      duration: 1000
                    });
                  }
                }
              })
            })
          }
        } else {
          return false;
        }
      });

    },
    addNode(node, data) {

      const nodeData = {
        icon: "el-icon-tickets",
        isChildren: true,
        level: 1,
        orgId: "0",
        orgName: "66666666",
        orgType: "0",
        pId: "",
        sort: 0,
        type: 1,
        children: [],
      }
      this.$refs.pubTree.append(nodeData, node, data)
    },
    addreset(orgType, type) {
      let _this = this;
      let getCurrentNode = _this.$refs.pubTree.getCurrentNode()
      let getNode = _this.$refs.pubTree.getNode(getCurrentNode)
      _this.selectOrgNum(getNode.data.orgId)
      _this.dialogStatus = 0;
      _this.dialogFormVisible = true;
      _this.dataForm.phone = '';
      _this.dataForm.phoneDL = '';
      _this.dataForm.email = '';
      _this.dataForm.emailDL = '';
      if (type == 2) {
        if (orgType == 10) {
          _this.dataForm.radioGroupChecked = "10"
        } else if (orgType == 11) {
          _this.dataForm.radioGroupChecked = "11"
        }
        let parent = getNode.parent.data
        _this.dataForm.company = parent.company != null ? parent.company : parent.orgName
        _this.dataForm.companyDL = parent.company != null ? parent.company : parent.orgName
        if (parent.hasOwnProperty('email')) {
          _this.dataForm.email = parent.email;
          _this.dataForm.emailDL = parent.email;
        }
        if (parent.hasOwnProperty('phone')) {
          _this.dataForm.phone = parent.phone;
          _this.dataForm.phoneDL = parent.phone;
        }
      } else if (type == 1) {
        if (orgType == 10) {
          _this.dataForm.radioGroupChecked = "10"
        } else if (orgType == 11) {
          _this.dataForm.radioGroupChecked = "11"
        }
        _this.dataForm.company = getCurrentNode.company != null ? getCurrentNode.company : getCurrentNode.orgName
        _this.dataForm.companyDL = getCurrentNode.company != null ? getCurrentNode.company : getCurrentNode.orgName
        if (getCurrentNode.hasOwnProperty('email')) {
          _this.dataForm.email = getCurrentNode.email;
          _this.dataForm.emailDL = getCurrentNode.email;
        }
        if (getCurrentNode.hasOwnProperty('phone')) {
          _this.dataForm.phone = getCurrentNode.phone;
          _this.dataForm.phoneDL = getCurrentNode.phone;
        }
      }
      _this.terminalOrgNumErrorMsg = ''
      _this.dataForm.selectValue = 0
      _this.dataForm.schoolName = '' //名称
      _this.dataForm.terminalOrgNum =
        _this.dataForm.adminName = ''//机构管理员账号
      _this.dataForm.adminNameDL = ''//机构管理员账号
      _this.dataForm.pickerValueOne = ''
      _this.dataForm.pickerValueTwo = ''
      _this.dataForm.adminPwd = '' //机构管理员密码
      _this.dataForm.adminPwdDL = '' //机构管理员密码
      /*_this.dataForm.schoolName = '' //名称
      _this.dataForm.terminalOrgNum =
      _this.dataForm.adminName = ''//机构管理员账号
      _this.dataForm.organizationNum = '' //机构数量
      _this.dataForm.organization = ''
      _this.dataForm.sort = '' //排序

      _this.dataForm.adminPwd = '' //机构管理员密码
      _this.dataForm.schoolId = ""
       ""*/
    },
    addTree(type) {//添加树节点  新增时，1.如果有上一级有公司、邮箱、手机号信息，应该默认填入上一级的相关信息；2.如果没有，公司则默认填入上一级的机构名称
      let _this = this
      _this.editRadio = false;
      _this.childAndSameLevel = type
      /*_this.dataForm.company = ''
      _this.dataForm.email = ''
      _this.dataForm.phone = ''
      _this.dataForm.pickerValue = ''
      _this.dataForm.selectValue = 0*/
      if (_this.getCurrentNode() == null) {
        _this.$message({
          message: _this.$t("organizationMge.warningGroup"),
          type: 'warning',
          duration: 1000
        });
        return false
      } else {
        let orgType = _this.getCurrentNode().orgType
        if (orgType == 11 && type == 1) {   //orgType 11是终端机构   type 1 是添加下级
          _this.$message({
            message: _this.$t("organizationMge.warningTerminal"),
            type: 'warning',
            duration: 1000
          });
        } else if (orgType == 10 && type == 2) { //代理机构添加同级
          this.addreset(10, 2)

        } else if (orgType == 10 && type == 1) { //代理机构添加下级
          this.addreset(10, 1)

        } else if (orgType == 11 && type == 2) { //终端机构添加同级
          this.addreset(11, 2)

        }
      }
    },
    editTree(node, data) {//修改树节点
      let _this = this
      _this.orgId = data.orgId
      _this.dialogStatus = 1;
      _this.dialogFormVisible = true;
      if (data.orgType == 10) {
        _this.editRadio = true;
      } else {
        _this.editRadio = true;
      }
      if (_this.firstOrgNum == "") { //判断是第一次获取OrgNum
        _this.selectOrgNum(data.orgId)
      } else {
        _this.orgNum = _this.firstOrgNum
      }
      _this.terminalOrgNumErrorMsg = ''
      _this.dataForm.adminPwd = '' //机构管理员密码
      _this.dataForm.adminPwdDL = '' //机构管理员密码
      _this.dataForm.company = ''
      _this.dataForm.companyDL = ''
      _this.dataForm.email = ''
      _this.dataForm.phone = ''
      _this.dataForm.emailDL = ''
      _this.dataForm.phoneDL = ''
      _this.dataForm.pickerValueOne = ''
      _this.dataForm.pickerValueTwo = ''
      _this.dataForm.selectValue = 0
      let param1 = new Object()
      let param = new Object()
      param1.orgId = data.orgId
      param.jsonBody = param1
      return new Promise((resolve, reject) => {
        selectOrgEntityByOrgId(param).then(res => {
          let jsonBodyData = res.jsonBody
          let msgBody = jsonBodyData.msgBody
          let rtnCode = jsonBodyData.rtnCode
          if (rtnCode == 0) {

            _this.$nextTick(() => {
              _this.dataForm.company = msgBody.company
              _this.dataForm.email = msgBody.email
              _this.dataForm.phone = msgBody.phone
              _this.dataForm.companyDL = msgBody.company
              _this.dataForm.emailDL = msgBody.email
              _this.dataForm.phoneDL = msgBody.phone
              _this.dataForm.selectValue = msgBody.mediaState
              if (msgBody.mediaState == 1) {
                _this.dataForm.pickerValueOne = msgBody.startDate
                _this.dataForm.pickerValueTwo = msgBody.stopDate
              }
              // _this.$nextTick(()=>{
              _this.dataForm.schoolId = msgBody.orgId
              _this.dataForm.radioGroupChecked = msgBody.orgType
              _this.dataForm.schoolName = msgBody.orgName //名称
              _this.dataForm.organizationNum = msgBody.limitChildAgency //机构数量
              _this.dataForm.sort = msgBody.sort //排序
              if (msgBody.orgType == 11) {
                let result = msgBody.userName.split(msgBody.orgNum);
                _this.dataForm.terminalOrgNum = msgBody.orgNum
                _this.dataForm.adminName = result[1] //机构管理员账号
              } else {
                _this.dataForm.terminalOrgNum = ""
                let result = msgBody.userName.split(_this.firstOrgNum);
                _this.dataForm.adminNameDL = result[1] //机构管理员账号
              }
              // _this.dataForm.adminName = msgBody.userName //机构管理员账号
              /*_this.dataForm.adminPwd = '' //机构管理员密码
              _this.dataForm.adminPwdDL = '' //机构管理员密码*/
              _this.dataForm.userId = msgBody.userId

              // })
            })
          } else {
            _this.dataForm.schoolId = ''
            _this.dataForm.schoolName = '' //名称
            _this.dataForm.organizationNum = '' //机构数量
            _this.dataForm.organization = ''
            _this.dataForm.sort = '' //排序
            _this.dataForm.adminName = '' //机构管理员账号
            _this.dataForm.adminNameDL = '' //机构管理员账号
            _this.dataForm.adminPwd = '' //机构管理员密码
            _this.dataForm.adminPwdDL = '' //机构管理员密码
            _this.orgNum = ''

          }
          // resolve(true)
        }).catch(err => {
          // reject(false)
        })
      })
    },
    delTree(node, data) {//删除树节点
      let _this = this
      _this.$confirm(this.$t("organizationMge.detTitle"), this.$t("organizationMge.title"), {
        confirmButtonText: _this.$t(" organizationMge.confirm"),
        cancelButtonText: _this.$t(" organizationMge.cancel"),
      }).then(() => {
        _this.$confirm(this.$t("organizationMge.detTitle"), this.$t("organizationMge.againTitle"), {
          confirmButtonText: _this.$t(" organizationMge.confirm"),
          cancelButtonText: _this.$t(" organizationMge.cancel"),
        }).then(() => {
          let param1 = new Object()
          let param = new Object()
          let _this = this
          let orgIdList = []
          orgIdList.push(data.orgId)
          param1.orgIdList = orgIdList
          param1.isDelOrgUser = true
          param.jsonBody = param1
          return new Promise((resolve, reject) => {
            deleteOrganization(param).then(res => {
              let jsonBodyData = res.jsonBody
              let rtnCode = jsonBodyData.rtnCode
              if (rtnCode == 0) {
                // _this.getSelectOrganizationInfo()
                _this.$message({
                  message: _this.$t("organizationMge.delSuccess"),
                  type: 'success',
                  duration: 1000
                })
                _this.tgetRootNode(data.pId)
                // _this.lowerOrgTreeByOrgId(data.orgId,1)
              } else if (rtnCode == 1211) {
                _this.$message({
                  message: _this.$t("organizationMge.delWarn"),
                  type: 'warn',
                  duration: 1000
                })
              } else {
                _this.$message({
                  message: _this.$t("organizationMge.delError"),
                  type: 'error',
                  duration: 1000
                })
                // _this.$message.error(_this.$t("organizationMge.delError"));
              }

              // resolve(true)
            }).catch(err => {
              // reject(false)
            })
          })
        })
      }).catch(() => {
      });
    },
    selectAgencyNumByOrgId(orgId) {
      let _this = this;
      let prame = Object()
      let prame1 = Object()
      prame1.orgId = orgId
      prame.jsonBody = prame1
      return new Promise((resolve, reject) => {
        selectAgencyNumByOrgId(prame).then(res => {
          // loading.close();
          _this.loading = false
          let jsonBody = res.jsonBody;
          let rtnCode = jsonBody.rtnCode;
          if (rtnCode == 0) {
            let rows = jsonBody.msgBody.children
            rows.forEach(function (element) {
              element.icon = "el-icon-tickets";
              element.type = 1;
            });
            let treeData = rows
            let getNode = _this.$refs.pubTree.getNode()
            // return false

            _this.$refs.pubTree.refreshLazyTree(getNode.node, treeData)
          } else {
            this.$message({
              message: jsonBody.msg,
              type: 'warning',
              duration: 1000
            });
          }
        })
      })
    },
    lowerOrgTreeByOrgId(orgId, type) {
      let _this = this;
      let prame = Object()
      let prame1 = Object()
      let getCurrentNode = _this.$refs.pubTree.getCurrentNode()
      let getNode = ""
      if (type == 0 && _this.childAndSameLevel == 1) {
        getNode = _this.$refs.pubTree.getNode(getCurrentNode)
        prame1.orgId = orgId
      } else {

        getNode = _this.$refs.pubTree.getNode(this.tnodePid)
        prame1.orgId = this.tnodePid
      }
      prame.jsonBody = prame1
      return new Promise((resolve, reject) => {
        selectLowerOrgTreeByOrgId(prame).then(res => {
          // loading.close();
          _this.loading = false
          let jsonBody = res.jsonBody;
          let rtnCode = jsonBody.rtnCode;
          if (rtnCode == 0) {
            let rows = jsonBody.msgBody.children
            rows.forEach(function (element) {
              element.icon = "el-icon-tickets";
              element.type = 1;
            });
            let treeData = rows
            let theChildren = getNode.childNodes
            theChildren.splice(0, theChildren.length)
            getNode.doCreateChildren(treeData)
            _this.$refs.pubTree.setCurrentKey(getNode.orgId)
          } else {
            this.$message({
              message: jsonBody.msg,
              type: 'warning',
              duration: 1000
            });
          }
        })
      })
    },
    getSelectLowerOrgTreeByOrgId(node, resolve) {
      let _this = this;
      let resolveNode = resolve
      if (_this.isPort == 1) {
        _this.treedata = _this.isPostData;
        _this.loading = false
      } else {
        let prame = Object()
        let prame1 = Object()
        prame1.orgId = node.key
        prame.jsonBody = prame1
        return new Promise((resolve, reject) => {
          selectLowerOrgTreeByOrgId(prame).then(res => {
            // loading.close();
            _this.loading = false
            let jsonBody = res.jsonBody;
            let rtnCode = jsonBody.rtnCode;
            if (rtnCode == 0) {
              let rows = jsonBody.msgBody.children
              rows.forEach(function (element) {
                element.icon = "el-icon-tickets";
                element.type = 1;
              });
              let treeData = rows
              let height = document.body.offsetHeight
              // _this.treeListStyle.height = height - 40 - 42 - 42 + "px"
              _this.treedata = treeData;
              resolveNode(treeData);
            } else {
              this.$message({
                message: jsonBody.msg,
                type: 'warning',
                duration: 1000
              });
            }
          })
        })
      }
    },
    tgetRootNode(orgId) {
      let _this = this;
      let prame = Object()
      let prame1 = Object()
      prame.jsonBody = prame1
      return new Promise((resolve, reject) => {
        selectUserOrgMediaTree(prame).then(res => {
          // loading.close();
          _this.loading = false
          let jsonBody = res.jsonBody;
          let rtnCode = jsonBody.rtnCode;
          if (rtnCode == 0) {
            let rows = jsonBody.msgBody
            rows.icon = "el-icon-tickets";
            rows.type = 1;
            let treeRowData = rows
            let height = document.body.offsetHeight
            _this.treeListStyle.height = height - 40 - 42 - 52 - 50 + "px";
            _this.treeListStyle['overflow-y'] = "auto"
            let treeDataList = []
            treeDataList.push(treeRowData)
            _this.treeDataList = treeDataList
            _this.selectCompany(orgId)
          } else {
            this.$message({
              message: jsonBody.msg,
              type: 'warning',
              duration: 1000
            });
          }
        })
      })
      // }
    },
    //学校树拖拽
    shoolDropCallBack(draggingNode, dropNode, dropType, ev) {
      // console.log(draggingNode)
    },
    //拖拽
    dropCallBack(draggingNode, dropNode, dropType, ev) {
      // console.log(draggingNode)
      // console.log(dropNode)
      // console.log(dropType)
      let prame = Object()
      let prame1 = Object()
      prame1.oldPId = draggingNode.data.pId
      prame1.nowOrgId = draggingNode.data.orgId
      prame1.oldOrgId = ""
      // prame1.nowSort = node.key
      if (dropType == "before") {
        prame1.nowPId = dropNode.data.pId
        prame1.oldSort = draggingNode.data.sort
        prame1.nowSort = dropNode.data.sort
        draggingNode.data.pId = dropNode.data.pId
      } else if (dropType == "after") {
        prame1.nowPId = dropNode.data.pId
        prame1.oldSort = draggingNode.data.sort
        prame1.nowSort = dropNode.data.sort + 1
        draggingNode.data.pId = dropNode.data.pId
      } else if (dropType == "inner") {
        prame1.nowPId = dropNode.data.orgId
        prame1.oldSort = draggingNode.data.sort
        prame1.nowSort = 0
        draggingNode.data.pId = dropNode.data.pId
      }

      prame1.isExchange = false
      prame.jsonBody = prame1
      return new Promise((resolve, reject) => {
        updateOrgOrder(prame).then(res => {
          let jsonBody = res.jsonBody;
          let rtnCode = jsonBody.rtnCode;
          if (rtnCode == 0) {

          } else {
            this.$message({
              message: jsonBody.msg,
              type: 'warning',
              duration: 1000
            });
          }
        })
      })
    },
    //批量删除组织机构
    deleteOrganization() {
      let _this = this
      let prame = Object()
      let prame1 = Object()
      let orgIdList = []

      orgIdList.push("")
      prame1.orgIdList = orgIdList
      prame1.isDelOrgUser = true
      prame.jsonBody = prame1
      return false
      return new Promise((resolve, reject) => {
        deleteOrganization(prame).then(res => {
          let jsonBody = res.jsonBody;
          let rtnCode = jsonBody.rtnCode;
          if (rtnCode == 0) {

          } else {
            _this.$message({
              message: jsonBody.msg,
              type: 'warning',
              duration: 1000
            });
          }
        })
      })
    },
    //查询用户是否有操作流媒体服务的权限
    selectUserMediaInfo() {
      selectUserMediaInfo().then(res => {
        let rtn = res.jsonBody.rtnCode;
        let msgBody = res.jsonBody.msgBody
        if (rtn === 0) {
          this.mediaOperator = msgBody.mediaOperator
        }
      })
    },
    //获取组织机构代码
    selectOrgNum(orgId) {
      let _this = this
      let prame = Object()
      let prame1 = Object()
      prame1.orgId = orgId
      prame.jsonBody = prame1
      return new Promise((resolve, reject) => {
        selectOrgNum(prame).then(res => {
          let jsonBody = res.jsonBody;
          let rtnCode = jsonBody.rtnCode;
          if (rtnCode == 0) {
            _this.orgNum = jsonBody.msgBody.orgNum
            _this.firstOrgNum = jsonBody.msgBody.orgNum
          } else {
            _this.$message({
              message: jsonBody.msg,
              type: 'warning',
              duration: 1000
            });
          }
        })
      })
    },
    //获取创建组织的前缀
    selectOrgEntityByOrgId() {
      let _this = this
      let prame = Object()
      let prame1 = Object()
      prame1.orgId = _this.entityByorgId
      prame.jsonBody = prame1
      return new Promise((resolve, reject) => {
        selectOrgEntityByOrgId(prame).then(res => {
          let jsonBody = res.jsonBody;
          let rtnCode = jsonBody.rtnCode;
          if (rtnCode == 0) {
            _this.orgNum = jsonBody.msgBody.orgNum
          } else {
            _this.$message({
              message: jsonBody.msg,
              type: 'warning',
              duration: 1000
            });
          }
        })
      })
    },

    tnodeCallBack(data) {
      let _this = this
      _this.tnodeOrgId = data.orgId
      _this.tnodePid = data.pId
      if (data.isTop) {
        _this.addSiblingType = data.isTop
      } else {
        _this.addSiblingType = false
      }
      let orgType = _this.getCurrentNode().orgType
      if (orgType == 11) {
        _this.addChildType = true
      } else {
        _this.addChildType = false
      }

    },
    //自定义节点内容
    renderContent(h, {node, data, store}) {
      if (data.isTop) {
        return (
          <span class="custom-tree-node">
            <span><span class="tree_font" style="margin-left: 4px;">{node.label}</span></span>
          <span>
          </span>
          </span>);
      } else {
        if (data.orgType == 11) {
          return (
            <span class="custom-tree-node">
              <span>
                <i class="file-btn-icon el-icon-control-terminal" style="margin-left: 5px;color: #11B9FF;"></i>
                <span class="tree_font" style="margin-left: 4px;">
                 {node.label}
                </span>
              </span>
            <span>
            <i class="group-list-right el-icon-control-edit " title={this.$t('organizationMge.edit')}
               on-click={() => this.editTree(node, data)}></i>
            <i class="group-list-right el-icon-control-delete " title={this.$t('organizationMge.del')}
               on-click={() => this.delTree(node, data)}></i>
            </span>
            </span>);
        } else {
          return (
            <span class="custom-tree-node">
              <span><span class="tree_font" style="margin-left: 4px;">{node.label}</span></span>
            <span>
            <i class="group-list-right el-icon-control-edit " title={this.$t('organizationMge.edit')}
               on-click={() => this.editTree(node, data)}></i>
            <i class="group-list-right el-icon-control-delete " title={this.$t('organizationMge.del')}
               on-click={() => this.delTree(node, data)}></i>
            </span>
            </span>);
        }

      }
    }
  },
  dialogCopy() {
    // var oInput = document.createElement('input');
    // oInput.value = '复制内容';
    // document.body.appendChild(oInput);
    // oInput.select();//选择对象
    // document.execCommand('copy');//执行浏览器复制命令
    // document.body.removeChild(oInput);
  },
  components: {
    tree
  }
}
</script>


<style lang="scss" rel="stylesheet/scss" scoped type="text/css">
.group-list-right {
  font-size: 20px;
  margin-left: 5px;
  cursor: pointer;
  color: #767e89;
  vertical-align: sub;
}

.group-list-right:hover {
  color: #00acf6;
}

.organizationStatus {
  margin-left: 20px;
  display: inline-block;
  width: 54px;
  height: 20px;
  opacity: 1;
  border-radius: 20px;
}

.organizationStatus-text {
  display: inline-block;
  width: 44px;
  height: 20px;
  opacity: 1;
  font-size: 10px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  margin: 0 auto;
  color: #ffffff;
  line-height: 14px;
}

/deep/ .elCol {
  border-bottom: none;
  margin: 20px;
  display: flex;
  justify-content: space-between;
}

/deep/ .groups {
  .el-tree-node {
    margin-left: 18px;

    .el-tree-node__content {
      border: 1px solid #d8dce5;
      margin-top: 2px;
      padding-right: 17px;
      padding-left: 0px !important;
      height: 40px;
      /*min-width: 366px;*/
      width: 395px;
    }

    .group-list-right {
      font-size: 20px;
      margin-left: 5px;
      cursor: pointer;
    }

    .group-list-right:hover {
      color: #00acf6;
    }

    .el-tree-node__content:hover {
      border: 2px solid #409eff;
      /*background-color: red;*/
    }
  }
}

/*.groups {
  margin-top: 20px;

  .el-tree-node {
    margin-left: 18px;

    .el-tree-node__content {
      border: 1px solid #d8dce5;
      margin-top: 2px; !*no*!
      padding-right: 17px;
      padding-left: 0px !important;
      height: 40px;
      min-width: 366px;
    }

    .el-tree-node__content:hover {
      border: 2px solid #409eff;
    }
  }

  .group-list-right {
    font-size: 17px;
    margin-left: 5px;
    cursor: pointer;
  }

  .el-tree-node__content:hover, .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #fff;
    border: 2px solid #409EFF !important;
    color: #606266 !important;
  }

  .el-tree-node__content > .el-tree-node__expand-icon {
    !*display: none;*!
    !*:before{}*!
  }

  .el-tree-node__expand-icon.expanded {
    -webkit-transform: rotate(0deg);
    ransform: rotate(0deg);
  }

  .el-icon-caret-right:before {
    content: "\e6d9";
  }

  .el-icon-caret-right {
    color: #767E89;
    font-size: 15px;
  }

  .el-tree-node__expand-icon.is-leaf {
    color: transparent !important;
    cursor: default;
  }

  .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
    content: "\e6d8";
  }

  .group-list-right {
    font-size: 17px;
    margin-left: 5px;
    cursor: pointer;
  }
}*/

/*.el-icon-control-copy {
  cursor: pointer;
}*/

/*whr*/
.contain {

  border-top: 1px solid #BFBFBF;
  display: flex;
  flex-direction: row;
  width: 100%;
  /*overflow-y: auto;*/
  /*min-height: 720px;*/
  height: 100%;
}

.left {
  padding: 20px 0;
  /*width: 468px;*/
  border-right: 1px solid #BFBFBF;
  /*min-height: calc(100vh - 189px);*/
  /*height: calc(100vh - 50px);*/
  /*height: 100%;*/
}

.right {
  width: 1300px;
  /*height: calc(100vh - 52px);*/
  height: 100%;
  padding: 20px;
  overflow: auto;
  /*height: 100%;*/
}

.right-content {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
}

.content-left-tree {
  border-radius: 8px;
  width: 437px;
  height: calc(100vh - 211px);
  display: flex;
  flex-direction: column;
  min-height: 400px;
  min-width: 264px;
  overflow: auto;
}

.card {
  margin-bottom: 20px;
  margin-right: 20px;
  width: 292px;
  height: 248px;
  background: #ffffff;
  border-radius: 2px;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.12);
  position: relative;

  .card-header {
    padding-left: 20px;
    width: 100%;
    height: 66px;
    border-bottom: 1px solid #d5d5d5;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .card-header-p-one {
      /*width: 89px;*/
      flex: 6;
      height: 19px;
      font-size: 16px;
      font-family: inter;
      font-weight: 700;
      text-align: left;
      color: #000000;
      line-height: 19px;
    }

    .card-header-p-two-bg {
      flex: 2;
      margin-right: 20px;
      width: 60px;
      height: 25px;
      opacity: 1;
      border: 1px solid;
      border-radius: 2px;

      .card-header-p-two {
        font-size: 14px;
        font-family: inter;
        font-weight: 700;
        text-align: center;
        /* color: #e02020;*/
        line-height: 25px;
      }
    }
  }

  .card-body {
    padding: 20px;

    .card-body-one {
      margin-bottom: 17px;
      /* height: 40px;*/
      .card-body-one-p1 {
        word-wrap: break-word;
        word-break: normal;
        /*height: 20px;*/
        opacity: 1;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #606266;
        line-height: 20px;
      }

      .card-body-one-p2 {
        word-wrap: break-word;
        word-break: normal;
        /*margin-left: 20px;*/
        /* height: 20px;*/
        opacity: 1;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #606266;
        line-height: 20px;
      }
    }

    .card-body-two {
      margin-bottom: 23px;

      .card-body-two-p1 {
        height: 28px;
        opacity: 1;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #606266;
        line-height: 28px;
      }

      .card-body-two-p2 {
        /*margin-left: 20px;*/
        /*height: 20px;
        margin-top: 11px;*/
      }
    }

    .card-body-three {
      margin-bottom: 10px;

      .card-body-three-p1 {
        height: 20px;
        opacity: 1;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #606266;
        line-height: 20px;
      }

      .card-body-three-p2 {
        /* margin-left: 20px;*/
        height: 20px;
        opacity: 1;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: right;
        color: #606266;
        line-height: 20px;
      }
    }

    .card-body-four {
      width: 252px;
      position: absolute;
      bottom: 15px;
    }

    .card-body-five {
      margin-bottom: 10px;

      .card-body-five-p1 {
        height: 20px;
        opacity: 1;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #606266;
        line-height: 20px;
      }

      .card-body-five-p2 {
        height: 20px;
        opacity: 1;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: right;
        color: #606266;
        line-height: 20px;
      }
    }
  }
}

.flex-between {
  display: flex;
  justify-content: space-between;
}

/deep/ .demo {
  height: 100%;
}

/deep/ .demo .el-switch__label {
  position: absolute;
  display: none;
  color: #fff;
}

/*按钮大小设置*/
/deep/ .demo .el-switch__core {
  height: 22px;
  width: 50px !important;
  border-radius: 12px;
}

/*按钮文字大小设置*/
/deep/ .el-switch__label * {
  line-height: 1;
  font-size: 10px;
  display: inline-block;

}

/*关闭时文字位置设置*/
/deep/ .demo .el-switch__label--left {
  z-index: 1;
  left: 23px;
}

/*开启时文字位置设置*/
/deep/ .demo .el-switch__label--right {
  z-index: 1;
  right: 27px;
}

/*开启时圆圈位置设置*/
/deep/ .el-switch.is-checked .el-switch__core::after {
  left: 100%;
  margin-left: -20px;
  top: 0px;
}

/*显示文字*/
/deep/ .demo .el-switch__label.is-active {
  display: block;
}

/*圈圈的大小*/
/deep/ .el-switch__core:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  border-radius: 10px;
  -webkit-transition: all .3s;
  transition: all .3s;
  width: 20px;
  height: 20px;
  background-color: #FFF;
}

/*@media screen and (min-width: 1920px) {
  .right-content {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;

    .card:nth-child(3n) {
      margin-right: 0;
    }
  }
}*/

/*@media screen and (max-width: 1919px) and (min-width: 1377px) {
  .right-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
  }
}*/

/*@media screen and (max-width: 1376px) {
  .right-content {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    flex-wrap: wrap;
  }
}*/

.el-input {
  width: 355px;
}

.pagination {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-end;
  margin: 20px 0;

}

.d-content-cox-rigth-btn {
  display: flex;
  height: 40px;
  width: 200px;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border: 1px solid #d5d5d5;
  border-radius: 5px;
  padding: 0px 10px;
  cursor: pointer;

  .d-content-cox-rigth-btn-title {
    font-size: 14px;
    color: #606266;
    font-weight: 400;
  }

  .d-content-cox-rigth-btn-icon {
    font-size: 10px;
    color: #000000;
  }
}

.Thumbnail {
  width: 120px;
  height: 40px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .Thumbnail-item {
    color: #767e89;
    flex: 1;
    text-align: center;
    line-height: 43px;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}

/*/deep/.el-popover{
  border: 1px solid #606266 !important;
}*/
.el-form-item {
  margin-bottom: 10px;
}

/deep/ .el-table .cell {
  word-wrap: break-word;
  word-break: normal;
}

/*.searchClass{
  width: 300px;
  height: 40px;
  background: #ffffff;
  border: 1px solid rgba(0,0,0,0.25);
  border-radius: 2px;
}*/
/*/deep/.el-col{
  .statusClass{
    width: 202px;
    height: 40px;
    background: #ffffff;
    border: 1px solid rgba(0,0,0,0.25);
    border-radius: 2px;
    top: 158px !important;
  }
}*/

/deep/ .d-content-cox-rigth-btn {
  border: 1px solid rgba(0, 0, 0, 0.25) !important;
  border-radius: 2px !important;

  .d-content-cox-rigth-btn-title {
    color: rgba(0, 0, 0, 0.43) !important;
  }
}

/deep/ .el-input__inner {
  border: 1px solid rgba(0, 0, 0, 0.25) !important;
  border-radius: 2px !important;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  //color: rgba(0, 0, 0, 0.43) !important;
}

/deep/ .el-button {
  border: none;
  font-size: 14px;
  font-family: inter;
  font-weight: 400;
}

/deep/ .el-tree {
  color: #767e89;
}

/deep/ .el-checkbox {
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: currentColor !important;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: currentColor !important;
    background-color: currentcolor !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/organizationMge/index.vue